module.exports = "<span class=\"pin\"></span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpPinIcon/adpPinIcon.html
// module id = 699
// module chunks = 0